import React from 'react';
import { LightbulbIcon, TrendingUpIcon, TrendingDownIcon, AlertCircleIcon } from 'lucide-react';
interface Insight {
  id: number;
  text: string;
  type: 'positive' | 'negative' | 'warning' | 'neutral';
}
interface BIInsightsProps {
  insights: Insight[];
}
export function BIInsights({
  insights
}: BIInsightsProps) {
  const getIcon = (type: string) => {
    switch (type) {
      case 'positive':
        return <TrendingUpIcon size={16} className="text-emerald-400" data-id="element-659" data-mp="2pmijd07p0bg3" />;
      case 'negative':
        return <TrendingDownIcon size={16} className="text-red-400" data-id="element-660" data-mp="2knfr6gct9zpj" />;
      case 'warning':
        return <AlertCircleIcon size={16} className="text-amber-400" data-id="element-661" data-mp="2ymfe9jkoe6jl" />;
      default:
        return <LightbulbIcon size={16} className="text-blue-400" data-id="element-662" data-mp="2tmkppmodht1p" />;
    }
  };
  const getBg = (type: string) => {
    switch (type) {
      case 'positive':
        return 'bg-emerald-500/10 border-emerald-500/20';
      case 'negative':
        return 'bg-red-500/10 border-red-500/20';
      case 'warning':
        return 'bg-amber-500/10 border-amber-500/20';
      default:
        return 'bg-blue-500/10 border-blue-500/20';
    }
  };
  return <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-5" data-id="element-663" data-mp="2q9yfptfwukmr">
      <div className="flex items-center mb-4 pb-3 border-b border-white/10" data-id="element-664" data-mp="2v8jgbtz2r6bq">
        <LightbulbIcon size={18} className="text-amber-400 mr-2" data-id="element-665" data-mp="30977cfnazn5y" />
        <h3 className="text-white font-semibold text-sm" data-id="element-666" data-mp="22mqb7dqb3fls">Automated Insights</h3>
      </div>

      <div className="space-y-3" data-id="element-667" data-mp="27kigd9fyoy7x">
        {insights.map(insight => <div key={insight.id} className={`flex items-start p-3 rounded-lg border ${getBg(insight.type)}`} data-id="element-668" data-mp="27iyyxfikkh4k">
            <div className="mt-0.5 mr-3 flex-shrink-0" data-id="element-669" data-mp="2cibinre5982x">
              {getIcon(insight.type)}
            </div>
            <p className="text-sm text-blue-100 leading-relaxed" data-id="element-670" data-mp="1jvh4tdbu16yf">
              {insight.text}
            </p>
          </div>)}
      </div>
    </div>;
}